module.exports = __webpack_public_path__ + "media/entities/1110-9192d4f7.png";